class EnumValueProvider {
    constructor(enums) {
        this.enums = enums || {};
    }

    registerEnum(id, enumDefinition){
        this.enums[id] = enumDefinition;
    }

    /**
     * get value from enum
     * @param string key - key which will be enumerated
     * @param string enumId - id of the enum registered in current instrance
     * @param returnObject bool - optional ( default false ), if true then output will be generated as an object with raw and value keys
     * @param defaultKey mixed - optional, if specified and exists in enumDef then it will be used as when no key is found in enumDef
     * @param specificPropertyOnly string - optional (''), if set and such property exists in enumDef then only values from this property will be returned
     * @return mixed - content of enumDef or object (see returnObject)
     */
    mapKey(key, enumId, defaultKey, returnObject, specificPropertyOnly){
        if (!this.enums.hasOwnProperty(enumId)){
            throw new Error(`There is no enum definition registered for id ${enumId}`);
        }

        let enumDef = this.enums[enumId];

        return EnumValueProvider.getValue(key, enumDef, defaultKey, returnObject, specificPropertyOnly);
    }

    /**
     * get value from enum
     * @param string key - key which will be enumerated
     * @param object enumDef - object where properties contains object with key property used to determine desired value
     * @param returnObject bool - optional ( default false ), if true then output will be generated as an object with raw and value keys
     * @param defaultKey mixed - optional, if specified and exists in enumDef then it will be used as when no key is found in enumDef
     * @param specificPropertyOnly string - optional (''), if set and such property exists in enumDef then only values from this property will be returned
     * @return mixed - content of enumDef or object (see returnObject)
     */
    static getValue(key, enumDef, defaultKey, returnObject, specificPropertyOnly) {
        let output = {};

        if (typeof (enumDef) !== 'object') {
            throw TypeError(`enumDef must contain enum definition`);
        }

        if (typeof (returnObject) === 'undefined') {
            returnObject = false;
        }
        if (typeof (specificPropertyOnly) === 'undefined') {
            specificPropertyOnly = '';
        }
        let enumValue;
        for (let property in enumDef) {
            if (enumDef[property].hasOwnProperty('key') && enumDef[property].key === key) {
                enumValue = enumDef[property];
                break;
            }
        }
        if (!enumValue && typeof (defaultKey) !== 'undefined') {
            for (let property in enumDef) {
                if (enumDef[property].hasOwnProperty('key') && enumDef[property].key === defaultKey) {
                    enumValue = enumDef[property];
                    break;
                }
            }
        }
        if (!enumValue) {
            throw Error(`Unable to match provided enum key "${key}" to enum value`);
        }

        let value;
        if (specificPropertyOnly) {
            if (typeof (enumValue) === 'object' && enumValue.hasOwnProperty(specificPropertyOnly)){
                value = enumValue[specificPropertyOnly];
            }
            else{
                throw Error(`enum value for key ${enumValue.key || enumValue} doesn't contain property ${specificPropertyOnly}`);
            }
        }
        else {
            value = enumValue;
        }
        if (returnObject) {
            output.raw = key;
            if (typeof (value) !== 'object') {
                output.value = value;
            }
            else {
                delete output.value;
                for (let i in value) {
                    output[i] = value[i];
                }
            }
        }
        else {
            output = value;
        }

        return output;
    }
}

export default EnumValueProvider;